import React from 'react';
import {
  Button,
  Card,
  Descriptions,
  Tag,
  Divider,
  Typography,
  Row,
  Col,
} from 'antd';
import {
  FileOutlined,
  CheckCircleFilled,
  FilePdfOutlined,
  CalendarOutlined
} from '@ant-design/icons';
import moment from 'moment';
import 'moment/locale/es';

const { Title, Paragraph } = Typography;

class VisualizarAutorizacionTrabajoMenor extends React.Component {
  formatDate = timestamp => {
    if (!timestamp) return 'No especificada';
    return moment(Number(timestamp)).format('DD/MM/YYYY');
  };

  render() {    const { autorizacionMenor } = this.props;
    console.log('🚀 ~ VisualizarAutorizacionMenor ~ render ~ autorizacionMenor:', autorizacionMenor);

    if (!autorizacionMenor) {
      return (
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <h2>No se ha encontrado la autorización</h2>
          <p>Por favor, verifique el código ingresado e intente nuevamente.</p>
        </div>
      );
    }

    return (
      <div className="visualizador-autorizacion">
        {/* <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <Tag color="green" style={{ fontSize: '16px', padding: '8px 16px' }}>
            <CheckCircleFilled /> AUTORIZACIÓN VERIFICADA
          </Tag>
        </div> */}

        <Card
          title={
            <Title level={4}>
              <FileOutlined /> Autorización de Trabajo para adolescente
            </Title>
          }
          style={{ marginBottom: '20px' }}
        >
          <Descriptions bordered column={1} size="middle">
            <Descriptions.Item label="Código de verificación">
              <strong>{autorizacionMenor.codigoUnicoVerificacion || 'ABC123456'}</strong>
            </Descriptions.Item>
            <Descriptions.Item label="Fecha de creación">
              {this.formatDate(autorizacionMenor.fecha_creacion)}
            </Descriptions.Item>
            <Descriptions.Item label="Número de acta de nacimiento">
              <strong>{autorizacionMenor.numero_acta_nacimiento || 'No especificado'}</strong>
            </Descriptions.Item>
            <Descriptions.Item label="Estado de firma">
              {autorizacionMenor.firmadoDigitalmente ? (
                <Tag color="green">Firmado digitalmente</Tag>
              ) : (
                <Tag color="orange">Sin firma digital</Tag>
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Tipo">
              {autorizacionMenor.tipoVenta || 'No especificado'}
            </Descriptions.Item>
          </Descriptions>
        </Card>

        <Card
          title={<Title level={4}><CalendarOutlined /> Datos del Empleador</Title>}
          style={{ marginBottom: '20px' }}
        >
          <Descriptions bordered column={1} size="middle">
            <Descriptions.Item label="Nombre o Razón Social">
              {autorizacionMenor.empleador && autorizacionMenor.empleador.nombre ? autorizacionMenor.empleador.nombre : 'No especificado'}
            </Descriptions.Item>
            <Descriptions.Item label="CUIT">
              {autorizacionMenor.empleador && autorizacionMenor.empleador.cuit ? autorizacionMenor.empleador.cuit : 'No especificado'}
            </Descriptions.Item>
            <Descriptions.Item label="Actividad">
              {autorizacionMenor.empleador && autorizacionMenor.empleador.actividad ? autorizacionMenor.empleador.actividad : 'No especificada'}
            </Descriptions.Item>
            <Descriptions.Item label="Domicilio">
              {autorizacionMenor.empleador && autorizacionMenor.empleador.domicilio ? autorizacionMenor.empleador.domicilio : 'No especificado'}
            </Descriptions.Item>
            <Descriptions.Item label="Domicilio donde trabaja el Menor">
              {autorizacionMenor.empleador && autorizacionMenor.empleador.domicilioActivdad ? autorizacionMenor.empleador.domicilioActividad : 'No especificado'}
            </Descriptions.Item>
          </Descriptions>
        </Card>        <div style={{ textAlign: 'center', margin: '40px 0' }}>
          {autorizacionMenor.urlMinio ? (
            <Button
              type="primary"
              size="large"
              disabled={!autorizacionMenor.urlMinio}
              icon={<FilePdfOutlined />}
              href={autorizacionMenor.urlMinio}
              target="_blank"
            >
              Descargar Documento Firmado
            </Button>
          ) : (
            <div>
              <Tag color="orange" style={{ fontSize: '14px', padding: '5px 10px', marginBottom: '10px' }}>
                Documento no disponible
              </Tag>
              <p>No se puede acceder al documento en este momento.</p>
            </div>
          )}
        </div>

        <div
          style={{
            backgroundColor: '#f5f5f5',
            padding: '15px',
            borderRadius: '5px',
            marginTop: '20px',
          }}
        >
          <Paragraph>
            <strong>Nota importante:</strong> Este documento electrónico
            certifica la autenticidad de la autorización de trabajo para el adolescente.
            La información presentada corresponde a los registros oficiales del
            Poder Judicial de Neuquén.
          </Paragraph>
          <Paragraph>
            Si necesita más información o tiene dudas sobre la validez de este
            documento, comuníquese con el organismo emisor.
          </Paragraph>
        </div>
      </div>
    );
  }
}

export default VisualizarAutorizacionTrabajoMenor;